import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { applyOssUpdate, hasOssUpdate, OSS_UPDATE_EVENT } from "../../lib/oss/sw";

export default function OssUpdateBanner() {
  const [show, setShow] = useState(() => hasOssUpdate());
  useEffect(() => {
    const on = () => setShow(true);
    window.addEventListener(OSS_UPDATE_EVENT, on);
    return () => window.removeEventListener(OSS_UPDATE_EVENT, on);
  }, []);
  if (!show) return null;
  return (
    <div
      role="status"
      data-testid="oss-update-banner"
      className="fixed inset-x-3 z-50 mx-auto flex max-w-md items-center gap-3 rounded-2xl bg-sky-700 p-3 pl-4 text-white shadow-xl"
      style={{ top: "calc(0.75rem + env(safe-area-inset-top))" }}
    >
      <p className="flex-1 text-sm font-medium">È disponibile una nuova versione dell'area OSS.</p>
      <button
        type="button"
        onClick={() => applyOssUpdate()}
        className="inline-flex h-11 items-center gap-2 rounded-xl bg-white px-4 text-base font-semibold text-sky-800"
      >
        <RefreshCw className="h-4 w-4" /> Aggiorna
      </button>
    </div>
  );
}
